// Centralized service categories data to be used across components

export interface ServiceItem {
  id: string;
  name: string;
  path: string;
}

export interface ServiceCategory {
  id: string;
  title: string;
  description: string;
  services: ServiceItem[];
}

// Organized services into categories
export const serviceCategories: ServiceCategory[] = [
  {
    id: 'product',
    title: 'Product Strategy & Growth',
    description: 'Transform your product vision into market reality. We help you build products users love and scale them effectively.',
    services: [
      { id: 'product-strategy', name: 'Product Strategy & Design', path: '/services/product' },
      { id: 'plg', name: 'Product-Led Growth', path: '/services/product-led-growth' }
    ]
  },
  {
    id: 'marketing',
    title: 'Content & Marketing',
    description: 'Tell your story with impact. Our content strategies position your brand as a leader and drive meaningful engagement.',
    services: [
      { id: 'content-marketing', name: 'Content Marketing', path: '/services/content-marketing' },
      { id: 'corporate-messaging', name: 'Corporate Messaging', path: '/services/corporate-messaging' }
    ]
  },
  {
    id: 'community',
    title: 'Community & Advocacy',
    description: 'Build movements, not just customer bases. We help you nurture vibrant communities that champion your brand.',
    services: [
      { id: 'customer-advocacy', name: 'Customer Advocacy', path: '/services/customer-advocacy' },
      { id: 'community-management', name: 'Community Management', path: '/services/community-management' }
    ]
  },
  {
    id: 'business',
    title: 'Business Expansion',
    description: 'Accelerate your market reach. From analyst relations to sales enablement, we open new pathways for growth.',
    services: [
      { id: 'analyst-relations', name: 'Analyst Relations', path: '/services/analyst-relations' },
      { id: 'sales-enablement', name: 'Sales Enablement', path: '/services/sales-enablement' }
    ]
  }
];

// Helper function to get all services flattened with category information
export const getAllServices = () =>
  serviceCategories.flatMap(category =>
    category.services.map(service => ({
      ...service,
      category: category.title,
      categoryId: category.id
    }))
  );
